var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _vm.defaultView
        ? _c("DocList", { key: `list-${_vm.$route.name}` })
        : _c("FileExplorer", { key: `explorer-${_vm.$route.name}` }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }